import axios from "axios";
import { toast } from "sonner";

export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API_URL, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    const protectedRequest = cfg.url === "/auth/me" || !cfg.url?.startsWith("/auth/");
    if (err.response?.status === 401 && !cfg._retry && protectedRequest) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(cfg);
      } catch (e) {
        refreshing = null;
        if ([401, 403].includes(e?.response?.status)) window.dispatchEvent(new Event("lbc:logout"));
        // A temporary refresh failure is not an invalid session. Preserve its status for the caller.
        return Promise.reject(e);
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!e?.response) return "Serveur injoignable. Tes données sont en sécurité, réessaie dans un instant.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return "Une erreur est survenue.";
}

export const fail = (e) => toast.error(errMsg(e));

export function actionToast(a) {
  if (!a) return;
  if (a.duplicate) return toast.info("Action déjà demandée : aucun doublon créé (idempotence).");
  if (a.status === "SUCCESS") return toast.success(a.delivery_proof === "EXTENSION_VERIFIED" ? "Envoi vérifié sur Leboncoin." : "Action appliquée et journalisée.");
  if (a.status === "UNVERIFIED") return toast.warning("Enregistré comme fait manuellement : non vérifié techniquement.", { duration: 7000 });
  if (a.mode === "COPILOT") return toast.warning(a.user_message || a.manual_instructions || "Action à effectuer manuellement.", { duration: 9000 });
  if (a.status === "WAITING_USER") return toast.info("Action préparée : valide-la dans la file d'actions.", { duration: 6000 });
  if (a.status === "QUEUED") return toast.success("Action en file d'exécution (Autopilot).");
  toast(a.status);
}

export const eur = (v) => (v === null || v === undefined ? null : `${Number(v).toLocaleString("fr-FR", { maximumFractionDigits: 2 })} €`);
export const pct = (v) => (v === null || v === undefined ? null : `${Number(v).toLocaleString("fr-FR", { maximumFractionDigits: 1 })} %`);
export const dt = (s) => (s ? new Date(s).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" }) : "—");
export const fileUrl = (id, v = "current") => `${API_URL}/files/${id}?v=${v}`;
